export enum CERTIFICATE_KINDS {
    all = 'all',
    MedicalGroupForTrains = 'MedicalGroupForTrains',
    Form291U = 'Form291U',
    Form070U = 'Form070U',
    processed = 'processed',
}
